import React from 'react';
import { Row, Col } from 'react-bootstrap';

import FieldTextArea from './FieldTextArea.jsx';

export default function PracticeDetails() {
  return (
    <div id="section-practice-comments">
      <Row>
        <Col xs={12}>
          <FieldTextArea field={'trackComments'} placeholder='Track Notes' />
        </Col>
        <Col xs={12}>
          <FieldTextArea field={'practiceComments'} placeholder='Practice Notes' />
        </Col>
      </Row>
    </div>
  );
}
